<table class="table table-bordered relation-table"
       [class.table-sm]="isSmallSize"
       [formGroup]="parentFormGroup">
  <thead class="thead-light">
  <tr>
    <th scope="col">
      Action
    </th>
    <th scope="col" *ngFor="let attributeControl of attributeControls">
      {{attributeControl.label}}<strong *ngIf="attributeControl.primaryKey" class="primaryKey">*</strong>
    </th>
  </tr>
  </thead>

  <tbody [formArrayName]="entityRelation.RELATION_ID">
    <tr *ngFor="let formGroup of formArray.controls; let i = index">
      <td class="actions">
        <button class="btn" [class.btn-sm]="isSmallSize" type="button" (click)="openDetailModal(i)" title="Detail">
          <span *ngIf="readonly" class="fas fa-search"></span>
          <span *ngIf="!readonly" class="fas fa-pen"></span>
        </button>
        <button class="btn" [class.btn-sm]="isSmallSize" type="button" [disabled]="readonly" (click)="deleteRelationInstance(i)" title="Delete">
          <span class="far fa-trash-alt"></span>
        </button>
      </td>
      <td *ngFor="let attributeControl of attributeControls">
        <dk-app-attribute [attributeControl]="attributeControl" [isSmallSize] = "isSmallSize"
                          [formGroup]="formGroup" [readonly]="readonly">

        </dk-app-attribute>
      </td>
    </tr>
  </tbody>
</table>

<div *ngIf="currentFormGroup" class="modal fade dk-modal-open" [ngClass]="{'show': isDetailModalShown}"
     [ngStyle]="{'display': displayDetailModal}" id="detailModal" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="detail">Line Detail</h5>
        <button type="button" class="close" (click)="closeDetailModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <dk-app-attribute-form *ngFor="let attributeControl of attributeControls"
                               [readonly]="readonly" [isSmallSize]="isSmallSize"
                            [attributeControl]="attributeControl" [formGroup]="currentFormGroup">
        </dk-app-attribute-form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" [class.btn-sm]="isSmallSize" (click)="closeDetailModal()">OK</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" [ngClass]="{'show': isErrorModalShown}"
     [ngStyle]="{'display': displayErrorModal}" id="errorModal" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="error">{{errorTitle}}</h5>
        <button type="button" class="close" (click)="closeErrorModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p>{{errorDescription}}</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" [class.btn-sm]="isSmallSize" (click)="closeErrorModal()">OK</button>
      </div>
    </div>
  </div>
</div>

